import React, { ReactNode, createContext } from 'react';
import { useTranslations } from 'use-intl';

const AlertContext = createContext<{
  alertText: string | undefined;
} | null>(null);
AlertContext.displayName = 'AlertContext';

export const useAlertContext = () => {
  const context = React.useContext(AlertContext);
  if (!context) {
    throw new Error('This hook must be used inside a AlertContextProvider');
  }
  return context;
};

export const AlertProvider = ({ children }: { children: ReactNode }) => {
  const t = useTranslations('Topbar');
  const statusText = t('Status.text');
  const statusAlert = statusText !== '' ? statusText : undefined;

  return (
    <AlertContext.Provider
      value={{
        alertText: statusAlert,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};
